var map = {
	"./adult/de/tulleord-data.json": 811,
	"./adult/nn/tulleord-data.json": 812,
	"./adult/no/tulleord-data.json": 813,
	"./youth/de/tulleord-data.json": 814,
	"./youth/nn/tulleord-data.json": 815,
	"./youth/no/tulleord-data.json": 816,
	"./youth/se/tulleord-data.json": 817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 810;